import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TWStaticAFLCard } from './TWStaticAFLCard'

export const TWStaticAFLCardRegistration = createRegisterableComponent(
    'tw-static-alf-card',
    () => <TWStaticAFLCard />,
)
